import * as z from "zod/v4";

const zoneMappingEntry_ = z.object({
  destinationZip: z.string(),
  zone: z.string(),
});
export type ZoneMappingEntry = z.infer<typeof zoneMappingEntry_>;

export const getUspsZoneMappings = {
  name: "getUspsZoneMappings" as const,
  input: z.object({
    originZip: z.string(),
    destinationZips: z.array(z.string()),
  }),
  output: z.object({ zoneMappings: z.array(zoneMappingEntry_) }),
};
